const frFR = {
    crossmintPayButtonService: {
        CONNECTING: "Connexion...",
        BUY: "Acheter avec Crossmint",
        BUY_WITH_ETH: "Acheter avec ETH",
        BUY_WITH_SOL: "Acheter avec SOL",
        BUY_WITH_CREDIT_CARD: "Acheter avec une carte de crédit",
    },
};
export default frFR;
